module.exports = __webpack_public_path__ + "static/media/cricket-ground.b1c2ffcc.png";